<button class="menuBtn actionsButton" [disabled]= "!actionsEnabled" [matMenuTriggerFor]="basketActionsMenu">{{'BASKET.actionsMenu'|translate}}</button>

<mat-menu #basketActionsMenu="matMenu" class="matMenu">
  <div class="menuContainer">
    <h4 class="title">{{'FILE.download' | translate}}</h4>
    <ul class="menuItem-container">
      <li class="menuItem"
        (click)="onDownload()">
        <mat-icon  fontSet="material-icons-outlined" class="m-r-5" >file_download</mat-icon>
        <span class="dataContainer">{{ (basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE ? 'BASKET.actions.downloadMySelection':'BASKET.actions.downloadAll') | translate}}</span>
      </li>
      <li class="menuItem"
        (click)="onDownloadPdf()">
        <mat-icon  fontSet="material-icons-outlined" class="m-r-5" >file_download</mat-icon>
        <span class="dataContainer">{{ (basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE ? 'BASKET.actions.downloadMySelectionPdf':'BASKET.actions.downloadAllPdf') | translate}}</span>
      </li>
      <li class="menuItem"
        (click)="onDownloadAnnotedPdf()">
        <mat-icon  fontSet="material-icons-outlined" class="m-r-5" >file_download</mat-icon>
        <span class="dataContainer">{{ (basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE ? 'BASKET.actions.downloadMySelectionAnnotedPdf':'BASKET.actions.downloadAllAnnotedPdf') | translate}}</span>
      </li>
    </ul>
    <h4 class="title">{{'FILE.export' | translate}}</h4>
    <ul class="menuItem-container">
      <li class="menuItem"
          (click)="onExportToExcel()">
        <mat-icon  fontSet="material-icons-outlined" class="m-r-5" >import_export</mat-icon>
        <span class="dataContainer">{{ (basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE ? 'BASKET.actions.exportMySelectionToExcel':'BASKET.actions.exportAllToExcel') | translate}}</span>
      </li>
    </ul>
    <ng-container *ngIf="isMsAlConfigOk">
      <h4 class="title">Send by email</h4>
      <ul class="menuItem-container">
        <li class="menuItem"
            (click)="onSendByEmail()">
          <mat-icon  fontSet="material-icons-outlined" class="m-r-5" >attach_email</mat-icon>
          <span class="dataContainer">{{ (basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE ? 'BASKET.actions.sendByEmailMySelection':'BASKET.actions.sendByEmailAll') | translate}}</span>
        </li>
      </ul>
    </ng-container>
    <ng-container *ngIf="basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE">
      <h4 class="title">{{'BASKET.actions.remove' | translate}}</h4>
      <ul class="menuItem-container">
        <li class="menuItem"
            (click)="onRemoveFromBasket()">
          <mat-icon  fontSet="material-icons-outlined" class="m-r-5" >remove_circle_outline</mat-icon>
          <span class="dataContainer">{{ ('BASKET.actions.removeFromBasketMySelection') | translate}}</span>
        </li>
      </ul>
    </ng-container>
    <h4 class="title">{{'BASKET.actions.delete' | translate}}</h4>
    <ul class="menuItem-container">
      <li class="menuItem"
          [ngClass]="!hasDeleteAccess ? 'disabledownload' : ''"
          (click)="onDelete()">
        <mat-icon  fontSet="material-icons-outlined" class="m-r-5" >close</mat-icon>
        <span class="dataContainer">{{ (basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE ? 'BASKET.actions.deleteBySelection':'BASKET.actions.deleteAll') | translate}}</span>
      </li>
      <li class="menuItem"
          *ngIf="hasHardDeleteAccess"
          (click)="onHardDelete()">
        <mat-icon  fontSet="material-icons-outlined" class="m-r-5" >delete</mat-icon>
        <span class="dataContainer">{{ (basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE ? 'BASKET.actions.hardDeleteBySelection':'BASKET.actions.hardDeleteAll') | translate}}</span>
      </li>
    </ul>
  </div>
  </mat-menu>
